import axios from "axios";
import { getHost } from "./utils";

export async function likeContent(
  contentId: string,
  access_token: string | undefined
) {
  if (!access_token) return null
  const host = getHost();
  return axios.get(
    `${host}/api/likes/${contentId}?access_token=${access_token}`
  );
}